export default "__VITE_ASSET__b5ab4b08__"